import { PostProperties } from "../types";
import image from "../img/lostGemDerrickCarter.jpg";

const post: PostProperties = {
  id: 43,
  title: "Derrick Carter - Passage, Vienna (05.08.2006)",
  content: `Derrick Carter, a true master of his craft, Carter started DJing when he was just ten years old. Widely regarded as one of the most influential house artists of all time, his career has inspired countless others.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/derrick-carter-passage-vienna-05-08-2006",
  category: "Lost Gem",
  translationsBg: {
    content: `Дерик Картър, истински майстор на занаята си, започва да се занимава с диджейство, когато е само на десет години. Считан за един от най-влиятелните хаус артисти на всички времена, кариерата му е вдъхновила безброй други.`,
  },
};

export default post;
